export default Object.freeze({
  FormTable: 'form-table',
  DynamicEntity: 'dynamic-entity',
  FormFieldAttachment: 'form-field-attachment',
});
